import { request } from "."

export const accountApi = {
  getUserInfo() {
    return request("/api/account")
  },
  login({ login, password }: { login: string, password: string }) {
    return request("/api/auth/login", { login, password })
  }
}